import { render, staticRenderFns } from "./sin.vue?vue&type=template&id=23fd64cb&scoped=true&"
import script from "./sin.vue?vue&type=script&lang=js&"
export * from "./sin.vue?vue&type=script&lang=js&"
import style0 from "./sin.vue?vue&type=style&index=0&id=23fd64cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fd64cb",
  null
  
)

export default component.exports